import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'

import { type MerchantRequest } from '../types/apiRequest'
import { type MerchantResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useRequest } = createRequestHelper<FortuneApis['get']['merchant'], MerchantResponse, MerchantRequest>({
  client: 'fortune',
  key: (params) => {
    if (!params) return null
    const { platform, project_code, index, service, user_id, site_id, country_code } = params
    if (!platform || !project_code || !index || !service || !user_id) {
      console.warn('[useApiGetMerchant] platform and project_code and index are required!')
      return null
    }
    if (service !== 'fast_pass') {
      console.warn('[useApiGetMerchant] service must be fast_pass!')
      return null
    }
    const paramsWithoutIndex = {
      platform,
      project_code,
      service,
      user_id,
      site_id,
      country_code,
    }
    return `/merchants/${index}?${queryStringify(paramsWithoutIndex)}`
  },

})

export const useApiGetMerchant = useRequest
